import { render } from "./IzinNonGtk.vue?vue&type=template&id=8725aff8"
import script from "./IzinNonGtk.vue?vue&type=script&lang=js"
export * from "./IzinNonGtk.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__